
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/technical-requirements",
      function () {
        return require("private-next-pages/technical-requirements.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/technical-requirements"])
      });
    }
  